<template>
  <router-view />
</template>

<script>
    export default {
        name: "ProfileContainer"
    }
</script>

<style scoped>

</style>